import { Link } from "react-router-dom";

const differentiators = [
  {
    icon: "ri-focus-3-line",
    title: "Precision in Every Detail",
    desc: "We believe great architecture lives in the details — materiality, proportion, light. Nothing is left to chance.",
  },
  {
    icon: "ri-map-pin-2-line",
    title: "Deep Local Knowledge",
    desc: "15+ years working with Santa Monica and Los Angeles planning departments, contractors, and consultants.",
  },
  {
    icon: "ri-team-line",
    title: "A True Collaborative Partner",
    desc: "We work with you, not for you. Your vision drives the process from concept through construction.",
  },
  {
    icon: "ri-award-line",
    title: "Portfolio That Speaks",
    desc: "Every project in our portfolio is a reference — clients are encouraged to visit built work before hiring us.",
  },
];

export default function WhyChoose() {
  return (
    <section className="py-24 lg:py-32 px-8 lg:px-14 bg-white">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
        {/* Image side */}
        <div className="relative">
          <div className="w-full h-[500px] lg:h-[640px] overflow-hidden rounded-lg">
            <img
              src="https://public.readdy.ai/ai/img_res/8a9f75123951e51ec6d49db83f355b80.jpg"
              alt="Studio 1323 architectural precision"
              className="w-full h-full object-cover object-top"
            />
          </div>
          {/* Floating stat card */}
          <div className="absolute -bottom-6 -right-6 bg-white border border-arch-border p-6 rounded-lg">
            <p className="font-serif text-5xl text-arch-charcoal font-light">60<span className="text-2xl">+</span></p>
            <p className="text-arch-gray text-xs tracking-wider uppercase mt-1 font-light">Projects Delivered</p>
          </div>
        </div>

        {/* Content side */}
        <div>
          <p className="text-arch-light text-xs tracking-[0.2em] uppercase mb-3">Why Studio 1323</p>
          <h2 className="font-serif text-4xl lg:text-5xl text-arch-charcoal font-light leading-tight mb-8">
            Architecture that<br />
            <em className="font-light">earns its place</em>
          </h2>
          <p className="text-arch-gray text-sm font-light leading-relaxed mb-10 max-w-md">
            We don't have a signature style we impose on every project. We have a rigorous process that leads to architecture that fits its site, serves its users, and endures.
          </p>

          <div className="space-y-8">
            {differentiators.map((item) => (
              <div key={item.title} className="flex items-start gap-4">
                <div className="w-9 h-9 flex items-center justify-center flex-shrink-0 border border-arch-border rounded-md">
                  <i className={`${item.icon} text-arch-charcoal text-base`} />
                </div>
                <div>
                  <h3 className="text-arch-charcoal text-sm font-semibold mb-1">{item.title}</h3>
                  <p className="text-arch-gray text-sm font-light leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>

          <Link
            to="/about"
            className="mt-10 inline-flex items-center gap-2 text-arch-charcoal text-xs tracking-[0.15em] uppercase font-medium border-b border-arch-charcoal pb-0.5 hover:text-arch-gray hover:border-arch-gray transition-colors cursor-pointer"
          >
            About the Firm
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}
